import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CertificatesComponent } from './certificates.component'
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '@ngx-interact-ui/core';
import { CertificateService } from '../../services/certificate.service';
import { DialogModule, ButtonModule, TableModule, MenuModule, SnackbarMessageModule, LabelModule } from '@ngx-interact-ui/core';

@NgModule({
  declarations: [CertificatesComponent],
  imports: [CommonModule,
    DialogModule,
    TranslateModule,
    ButtonModule,
    TableModule,
    SnackbarMessageModule,
    MenuModule,
    LabelModule,
    TooltipModule
  ],
  exports: [CertificatesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [CertificateService]
})
export class CertificatesModule { }